/*
 * @Author: your name
 * @Date: 2020-10-22 13:21:51
 * @LastEditTime: 2021-03-02 14:20:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\utils\request.js
 */
import axios from "axios";
import store from "@/store";
// 引入进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";
// create an axios instance
const service = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api"
      : process.env.VUE_APP_BASE_API,
  // baseURL: '/api',
  timeout: 30000, // request timeout
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

// request interceptor
// 添加请求拦截器
service.interceptors.request.use(
  config => {
    NProgress.start();
    // 开启请求加载loading
    store.state.isLoading = true;
    //为请求头对象，添加token验证的token字段
    if (sessionStorage.getItem("token")) {
      config.headers.token = sessionStorage.getItem("token");
    }
    return config;
  },
  error => {
    errorGet();
    // Do something with request error
    Promise.reject(error);
  }
);

// respone interceptor
// 添加响应拦截器
service.interceptors.response.use(
  response => {
    NProgress.done();
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.data.code == 0) {
      //请求结束后loading隐藏
      store.state.isLoading = false;
      return Promise.resolve(response);
    } else {
      Message({
        message: response.data.msg,
        type: "error",
        showClose: true,
        duration: 3000
      });
      errorGet();
      return Promise.reject(response);
    }
  },
  error => {
    // 错误处理
    if (error.response.status) {
      Message({
        message: error.response.data.msg,
        type: "error",
        showClose: true,
        duration: 3000
      });
      errorGet();
      return Promise.reject(error.response);
    }
  }
);
function errorGet() {
  setTimeout(function() {
    //请求有误后loading隐藏
    store.state.isLoading = false;
  }, 1500);
}
export default service;
